<template>
  <div>
    <div class="d-flex justify-content-between">
      <div class="mb-2">
        <div class="product-category-name">
          {{ selectedProduct.item_group }}
        </div>
        <div :class="['product-title', { dark: theme == themes.DARK }]">
          {{ selectedProduct.item_name || selectedProduct.name }}
          <span class="variant-subtitle">[{{ isVariant ? "Variant" : "Master Product" }}]</span>
        </div>
        <div>Catalog SKU - {{ selectedProduct.catalog_sku }}</div>
      </div>
      <div class="d-flex flex-column justify-content-end">
        <Button noMargin v-if="canAddVariants" @click="$emit('add-variant')">
          Add Variants <i class="fas fa-plus"></i>
        </Button>
        <p v-else-if="!isVariant" class="add-variants-unavailable" role="status">
          New variations are unavailable while this master is archived or disabled.
        </p>
        <Button noMargin class="archive-button" @click="$emit('archive')">
          Archive {{ !isVariant ? "Product" : "Variant" }}
          <i class="fas fa-box-archive"></i>
        </Button>
      </div>
    </div>
    <div class="my-3">
      <img class="product-img" :src="getServerAssetUrl(selectedProduct.image)" />
    </div>
  </div>
</template>

<script>
import Button from "../UI/Button.vue"
import { getServerAssetUrl } from "../../utils/common"

export default {
  components: { Button },
  props: {
    selectedProduct: {
      type: Object,
      required: true,
    },
    isVariant: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: "",
    },
    themes: {
      type: Object,
      required: true,
    },
  },
  computed: {
    canAddVariants() {
      if (this.isVariant) return false
      const status = String(this.selectedProduct.product_status || "").trim().toLowerCase()
      const disabled = [true, 1, "1", "true"].includes(this.selectedProduct.disabled)
      return status !== "archived" && !disabled
    },
  },
  methods: {
    getServerAssetUrl,
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.product-category-name {
  color: $secondaryColor;
  font-size: 1.5rem;
}

.product-title {
  color: $primaryColor;
  font-weight: bold;
  font-size: 1.5rem;

  &.dark {
    color: $secondaryColor;
  }
}

.variant-subtitle {
  font-size: 0.9rem;
  color: rgba($textColor, 0.6);
}

.product-img {
  max-height: 250px;
  max-width: 100%;
}

.archive-button {
  background: $dangerColor;
  margin-top: 10px;
}

.add-variants-unavailable {
  max-width: 260px;
  margin: 0 0 10px;
  color: rgba($textColor, 0.68);
  font-size: 0.82rem;
  line-height: 1.35;
  text-align: right;
}
</style>
